<div style="display:none">
  <div id="datasection">
    <div class="wrapper">
      <table class="full-width ">
        <tr style="vertical-align:top; text-align: center; ">
          <td colspan="6" class="reportTitle_ar">
            <img alt="" src="../../../../assets/images/ora/1.png" style="width:85%;margin-left: 0;height:65px;">
          </td>
        </tr>
        <tr style="vertical-align:top; text-align: center;">
          <td colspan="6">{{'REQUESTORDER' | translate}}</td>
        </tr>
      </table>
      <table class="full-width">
        <tbody>
          <tr>
            <td class="groupHeaderLabelCell_ar"><strong style="text-decoration: none !important;">Q.R No:</strong></td>
            <td class="groupHeaderDataCell_ar">{{row?.code}}</td>
            <td class="groupHeaderLabelCell_ar"><strong style="text-decoration: none !important;">{{'REQUESTORDER' |
                translate}}</strong></td>
            <td class="groupHeaderDataCell_ar">{{ row?.regDate | date :'dd-MM-yyyy'}}</td>
          </tr>
          <tr *ngIf="row?.description !=' '">
            <td class="groupHeaderLabelCell_ar"><strong style="text-decoration: none !important;">Company Name:</strong>
            </td>
            <td class="groupHeaderDataCell_ar">{{translate.currentLang == 'ar' ? 'شركة عالم سيجال':'Sigal World of
              Medical Services'}}</td>
          </tr>
          <tr>
            <td class="groupHeaderLabelCell_ar"><strong style="text-decoration: none !important;">
                {{translate.currentLang ==
                'ar' ? ' :اسم المورد' :'Contact person: '}} </strong></td>
            <td class="groupHeaderDataCell_ar">{{translate.currentLang == 'ar' ? row?.supliersNameAr :
              row?.supliersNameEn}}
            </td>
          </tr>
          <tr>
            <td class="groupHeaderLabelCell_ar">
              <div style="text-decoration: none !important;">{{row?.description}}</div>
            </td>
          </tr>
        </tbody>
      </table>
      <table class="full-width">
        <tr style="text-align: center;">
          <td class="groupHeaderLevel1_ar">{{'Sr' | translate}}</td>
          <td class="groupHeaderLevel1_ar">{{'Item desc' | translate}}</td>
          <td class="groupHeaderLevel1_ar">{{'Manufacturer' | translate}}</td>
          <td class="groupHeaderLevel1_ar">{{'Catalog Number' | translate}}</td>
          <td class="groupHeaderLevel1_ar">{{'UOM (box, pcs) ' | translate}}</td>
          <td class="groupHeaderLevel1_ar">{{'Qty' | translate}}</td>
        </tr>
        <tbody>
          <tr *ngFor="let item of items" style="text-align: center;">
            <td class="detailBand_ar">{{item.customCode}}</td>
            <td class="detailBand_ar">{{translate.currentLang == 'ar' ? item.nameAr : item.nameEn}}</td>
            <td class="detailBand_ar">{{item.manufacturing}}</td>
            <td class="detailBand_ar">{{item.technicalSpecifications}}</td>
            <td class="detailBand_ar">{{translate.currentLang == 'ar' ? item.unitNameAr : item.unitNameEn}}</td>
            <td class="detailBand_ar">{{item.quantity}}</td>
          </tr>
          <tr>
            <td colspan="8"></td>
          </tr>
        </tbody>
      </table>

      <table class="full-width">
        <tr>
          <td class=""><strong style="text-decoration: none !important;">{{'Procurement Officer' | translate}}</strong>
          </td>
          <td class=""><strong style="text-decoration: none !important;">{{'Procurement Manager' | translate}}</strong>
          </td>
        </tr>
      </table>
    </div>
  </div>
</div>
<app-print-page #printComponent section="datasection"></app-print-page>